import { render, staticRenderFns } from "./icon-editor.vue?vue&type=template&id=307f2574&scoped=true"
import script from "./icon-editor.vue?vue&type=script&lang=js"
export * from "./icon-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307f2574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307f2574')) {
      api.createRecord('307f2574', component.options)
    } else {
      api.reload('307f2574', component.options)
    }
    module.hot.accept("./icon-editor.vue?vue&type=template&id=307f2574&scoped=true", function () {
      api.rerender('307f2574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-button/icon-editor.vue"
export default component.exports